import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { getLatestTaskList } from "../Firebase/getLatestTaskListAction";
import * as idb from '../../../functions/databaseService/indexedDB';
import signOut from "../../../functions/userIdentity/signOut";
import { getItem } from "../../../utils/storageHelper";
import * as Sentry from "@sentry/capacitor";
// Action Types
export const FIREBASE_ADD_TASK_SUCCESS = "FIREBASE_ADD_TASK_SUCCESS";
export const FIREBASE_ADD_TASK_ERROR = "FIREBASE_ADD_TASK_ERROR";

// Thunk Action Creator
export const addTodoToFirebase = createAsyncThunk(
    "api/Task/addTodo",
    async (json, { dispatch }) => {

        const firebaseData = await getItem(`firebase:user:${import.meta.env.VITE_PUBLIC_APP_ENV}`);
        const user = JSON.parse(firebaseData);
        try {
            const online = navigator.onLine;

            if (online) {
                const response = await axios.post(
                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/addTodo`,
                    {
                        Title: json.title,
                        ParentId: json.parentId,
                        Type: json.type,
                        DueDate: json.dueDate,
                        NotificationDate: json.notificationDate
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
                if (response.status === 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }
                else if (response.status === 302) {
                    console.log("A redirect has happened, likely due to a server restart");
                    throw new Error("The last task has not been saved. Logging the user out");
                }
                else {
                    throw new Error("Error adding task to firebase");
                }
                //get data from indexed DB
                //const taskListData = await idb.getTasks();

                dispatch({
                    type: FIREBASE_ADD_TASK_SUCCESS,
                    payload: response.data,
                });
                
                // Return the updated task list for use with .unwrap()
                return response.data;
            }
            else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: FIREBASE_ADD_TASK_SUCCESS,
                        payload: taskListData
                    });
                    
                    // Return the task list for use with .unwrap()
                    return taskListData;
                }
                else {
                    console.log("No tasks found in IndexedDB");
                    throw new Error("No tasks found in IndexedDB");
                }
            }
           

        }
        catch (error) {
            Sentry.captureException(error, {
                tags: {
                    error_type: 'task_add_failure',
                    operation: 'addTodoToFirebase',
                    is_online: navigator.onLine,
                },
                level: 'error',
                extra: {
                    status_code: error.response?.status,
                }
            });
            dispatch({ type: FIREBASE_ADD_TASK_ERROR, payload: error });
            await signOut();
        }

            
    }
);